import React from 'react';
import PropTypes from 'prop-types';

export default function JobOfflineSidebar({ sidebarOpen, jobs, onDelete, onClose }) {
  return (
    <div className="w-96 max-w-full h-auto max-h-[calc(100vh-4rem)] bg-white shadow-2xl rounded-2xl border border-gray-200 flex flex-col">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 p-6 z-10 rounded-t-2xl">
        <div className="flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-800">My Offline Job Postings</h3>
          <button
            onClick={onClose}
            type="button"
            className="text-gray-400 hover:text-red-500 text-2xl font-bold transition-colors duration-200 hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center"
            title="Close"
          >
            &times;
          </button>
        </div>
      </div>

      {/* Job List */}
      <div className="p-6 overflow-y-auto flex-1">
        {jobs.length > 0 ? (
          <div className="space-y-4">
            {jobs.map(j => (
              <div
                key={j.id}
                className="bg-gradient-to-r from-gray-50 to-white p-4 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-[1.02]"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <div className="font-semibold text-gray-800 mb-1">{j.title}</div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs mr-2">
                        {j.job_type}
                      </span>
                      <span className="inline-block bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                        {j.job_location}
                      </span>
                    </div>
                    <p className="text-xs text-gray-500 mt-2 line-clamp-2">
                      {j.jd.length > 96 ? j.jd.slice(0, 96) + '...' : j.jd}
                    </p>
                  </div>
                  <button
                    onClick={() => onDelete(j.id)}
                    type="button"
                    className="ml-3 px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded-md text-sm transition-colors duration-200 shadow-sm hover:shadow-md"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="text-gray-400 text-lg mb-2">📋</div>
            <p className="text-gray-500">No offline jobs created yet.</p>
          </div>
        )}
      </div>
    </div>
  );
}

JobOfflineSidebar.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  jobs: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};